export { default as useBatchCreateSmartContractShares } from './useBatchCreateSmartContractShares';
